import type { IModule, ModuleContext } from '@punica/editor';
import { ModuleLifecycleState } from '@punica/editor';
import { MODULE_NAMES } from '@punica/editor';

import { sidebarDock } from '../sidebarDock/index.js';

/**
 * Shell ActivityBar module.
 * Depends on: kernel.commands, runtime.workspace
 */
export class ActivityBarModule implements IModule {
  readonly name = MODULE_NAMES.SHELL.ACTIVITY_BAR;
  readonly version = '1.0.0';
  readonly dependencies: readonly string[] = [
    MODULE_NAMES.KERNEL.COMMANDS,
    MODULE_NAMES.RUNTIME.WORKSPACE
  ];

  #state: ModuleLifecycleState = ModuleLifecycleState.CREATED;

  get state(): ModuleLifecycleState {
    return this.#state;
  }

  async bootstrap(context: ModuleContext): Promise<void> {
    const { punica, registry } = context;

    const commandsState = registry.getState(MODULE_NAMES.KERNEL.COMMANDS);
    const workspaceState = registry.getState(MODULE_NAMES.RUNTIME.WORKSPACE);

    if (commandsState !== ModuleLifecycleState.BOOTSTRAPPED) {
      throw new Error(
        'kernel.commands must be bootstrapped before shell.activityBar'
      );
    }
    if (workspaceState !== ModuleLifecycleState.BOOTSTRAPPED) {
      throw new Error(
        'runtime.workspace must be bootstrapped before shell.activityBar'
      );
    }

    if (!punica.shell?.ActivityBar?.manager) {
      throw new Error('ActivityBar manager not available');
    }
  }

  async start(context: ModuleContext): Promise<void> {
    // Pick the sidebar presentation (docked column on desktop, overlay drawer
    // on tablet) and restore its remembered width. Safe before the layout has
    // rendered — the controller re-applies on the first visibility change.
    sidebarDock.init();
  }
}
